module.exports = __webpack_public_path__ + "img/14.6c248954.jpg";